import { useQuery } from '@tanstack/react-query';
import { useOrganizationStore } from '@/core/stores/organization.store';
import { projectsService } from '../api/projects.service';
import { PROJECT_KEYS } from './queryKeys';

export function useProject(projectId: string | null) {
  const orgId = useOrganizationStore((s) => s.activeOrganizationId);

  return useQuery({
    queryKey: PROJECT_KEYS.detail(orgId ?? '', projectId ?? ''),
    queryFn: ({ signal }) => projectsService.getById(projectId!, signal),
    enabled: !!projectId && !!orgId,
    staleTime: 120_000,
  });
}
